import { Member } from 'functions/src/types/firestore/Game/Tournament/Guestlist';

export const createRowKey = (team1Member: Member, team2Member: Member) => {
  return `${team1Member?.userId}-${team2Member?.userId}`;
};
